import React from 'react';
import { AwardIcon, BadgeCheckIcon } from 'lucide-react';
import { CompanyPageLayout } from '../components/CompanyPageLayout';
const milestones = [['2026', 'Responsible travel recognition', 'Recognised by local partners for long-term community collaboration and mindful group travel.'], ['2024', 'Traveller choice award', 'Honoured for thoughtful planning, clear communication, and consistently personal service.'], ['2021', 'Mountain safety commitment', 'Completed updated emergency-preparedness and high-altitude response training across our trek leadership team.'], ['2008', 'Tour in Nepal begins', 'Founded with one guiding idea: make Nepal journeys feel more rooted, responsible, and human.']];
export function AwardsAndAchievement() {
  return <CompanyPageLayout eyebrow="Awards and achievement" title="Recognition that keeps us accountable." intro="The milestones that matter most reflect steady local relationships, careful leadership, and the trust travellers place in our team." data-id="element-320">
      <section className="px-5 py-20 sm:px-8 sm:py-28 lg:px-12" data-id="element-321">
        <div className="mx-auto max-w-[980px]" data-id="element-322">
          <div className="flex items-start gap-5 border-b border-[#cfd3c8] pb-10" data-id="element-323">
            <AwardIcon className="h-9 w-9 shrink-0 text-[#4f8057]" aria-hidden="true" data-id="element-324" />
            <p className="max-w-2xl text-xl leading-9 text-[#40564a]" data-id="element-325">
              We see awards as a marker, not a finish line. Every recognition is
              a reason to keep listening, improving, and caring for the details.
            </p>
          </div>
          <ol className="mt-12 border-l border-[#9eaa9e] pl-8 sm:ml-6 sm:pl-12" data-id="element-326">
            {milestones.map(([year, title, text]) => <li key={year} className="relative pb-12 last:pb-0" data-id="element-327">
                <span className="absolute -left-[41px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-4 border-[#f8f5ed] bg-[#4f8057] sm:-left-[57px]" data-id="element-328">
                  <span className="sr-only" data-id="element-329">Milestone</span>
                </span>
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#4f8057]" data-id="element-330">
                  {year}
                </p>
                <h2 className="mt-3 font-serif text-3xl" data-id="element-331">{title}</h2>
                <p className="mt-3 max-w-2xl leading-7 text-[#52635a]" data-id="element-332">
                  {text}
                </p>
              </li>)}
          </ol>
          <aside className="mt-14 flex gap-4 border border-[#a9cba7] bg-[#e1efdc] p-6 text-[#17362e]" data-id="element-333">
            <BadgeCheckIcon className="mt-1 h-6 w-6 shrink-0 text-[#315c3b]" aria-hidden="true" data-id="element-334" />
            <p className="leading-7" data-id="element-335">
              We are happy to share supporting credentials and local references
              when you are considering a journey with us.
            </p>
          </aside>
        </div>
      </section>
    </CompanyPageLayout>;
}